import { FC } from 'react';
import { useField } from 'react-final-form';

import clsx from 'clsx';
import { useFloorMap } from 'src/components/FloorMap/FloorMapProvider';
import { ParkingPlace } from 'src/components/ParkingPlace/ParkingPlace';
import { Parking } from 'src/types';

import { SpaceBookingObjectOption } from '../types';

import classes from './SpaceParkingPlace.module.scss';

export interface SpaceParkingPlaceProps {
  item: Parking;
}

export const SpaceParkingPlace: FC<SpaceParkingPlaceProps> = ({ item }) => {
  const { floor } = useFloorMap();
  const groups =
    useField<Map<number, SpaceBookingObjectOption[]>>('groups').input.value;

  const active = floor?.floorId
    ? !!groups.get(floor.floorId)?.find(d => d.id === item.id)
    : false;

  return (
    <ParkingPlace
      item={item}
      className={clsx(classes.container, active && classes.active)}
      contentClassName={clsx(classes.title)}
    />
  );
};
